<template>
  <div class="login-container">
    <el-row style="margin: 0 20px;">
      <el-col style="margin-top: 20vh;" :xs="24" :sm="{ span: 18, offset: 3 }" :md="{ span: 16, offset: 4 }"
        :lg="{ span: 10, offset: 7 }" :xl="{ span: 10, offset: 7 }">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
          <!--<b style="font-size: 30px;">欢迎登录风铃博客</b>-->
          <h3 class="title">欢迎登录风铃笔记</h3>
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="请输入账号">
              <i slot="prefix" class="el-input__icon el-icon-user-solid" />
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" type="password" auto-complete="off" placeholder="请输入密码" show-password
              @keyup.enter.native="handleLogin">
              <i slot="prefix" class="el-input__icon el-icon-lock" />
            </el-input>
          </el-form-item>
          <el-form-item prop="code" v-if="captchaEnabled">
            <div style="display: flex; align-items: center;">
              <el-input v-model="loginForm.code" auto-complete="off" placeholder="请输入验证码"
                @keyup.enter.native="handleLogin">
                <i slot="prefix" class="el-input__icon el-icon-key" />
              </el-input>
              <div class="login-code">
                <img :src="codeUrl" alt="" @click="getCode" class="login-code-img" />
              </div>
            </div>
          </el-form-item>
          <el-checkbox v-model="loginForm.rememberMe" style="margin:0 0 25px 0;">记住密码</el-checkbox>
          <el-form-item style="width:100%;">
            <el-button :loading="loading" size="medium" type="primary" style="width:100%;"
              @click.native.prevent="handleLogin">
              <span v-if="!loading">登 录</span>
              <span v-else>登 录 中...</span>
            </el-button>
            <div style="float: right;" v-if="register">
              <span>没有账号？</span> <el-button type="text" @click="toRegister()">去注册</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!--  底部  -->
    <div class="el-login-footer">
      <span>Copyright © {{ copyrightTime }} fengling.work All Rights Reserved.</span>
    </div>

    <!-- <div class="flower">
      <img src="@/assets/img/huaban2.png" alt="">
      <img src="@/assets/img/huaban3.png" alt="">
      <img src="@/assets/img/huaban1.png" alt="">
      <img src="@/assets/img/huaban6.png" alt="">
      <img src="@/assets/img/huaban4.png" alt="">
      <img src="@/assets/img/huaban3.png" alt="">
      <img src="@/assets/img/huaban6.png" alt="">
      <img src="@/assets/img/huaban9.png" alt="">
      <img src="@/assets/img/huaban4.png" alt="">
      <img src="@/assets/img/huaban5.png" alt="">
      <img src="@/assets/img/huaban8.png" alt="">
      <img src="@/assets/img/huaban7.png" alt="">
      <img src="@/assets/img/huaban7.png" alt="">
    </div> -->
  </div>
</template>

<script>
import { getCodeImg, getRegisterStatus } from "@/api/login";
import Cookies from "js-cookie";
import { decrypt, encrypt } from "@/utils/jsencrypt";
import { getCopyrightTime } from "@/utils/date";

export default {
  name: "Login",
  data() {
    return {
      codeUrl: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" }
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" }
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }]
      },
      loading: false,
      // 注册开关
      registerEnable: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: true,
      redirect: undefined,
      copyrightTime: getCopyrightTime()
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    this.getRegisterStatus();
    this.getCode();

  },
  mounted() {
    if (this.isBrowser()) {
      this.loadSakura();
      this.getCookie();
    }
  },
  beforeDestroy() {
    if (this.isBrowser()) {
      this.stopSakura();
    }
  },
  metaInfo() {
    return {
      title: '欢迎登录 | 风铃笔记',
    }
  },
  methods: {
    loadSakura() {
      // 先检查是否已经存在樱花容器
      if (document.getElementById('canvas_sakura')) {
        return;
      }
      const scriptEl = document.createElement('script')
      scriptEl.src = '/sakura.js'  // 自动从 public 目录加载
      scriptEl.async = true
      scriptEl.onload = () => {
        console.log('樱花动画加载成功')
      }
      scriptEl.onerror = () => {
        console.error('加载 sakura.js 失败，请检查路径是否正确')
      }
      document.head.appendChild(scriptEl);
    },
    stopSakura() {
      if (typeof stopSakura === 'function') {
        stopSakura();
      }
    },
    isBrowser() {
      return typeof window !== "undefined";
    },
    // 查询注册状态，是否可以注册
    getRegisterStatus() {
      getRegisterStatus().then(res => {
        this.registerEnable = res.data;
      });
    },
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.data.img;
          this.loginForm.uuid = res.data.uuid;
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove('rememberMe');
          }
          this.$store.dispatch("Login", this.loginForm).then(() => {
            this.$modal.msgSuccess('登录成功')
            this.$router.push({ path: this.redirect || "/" }).catch(() => { });
          }).catch(() => {
            this.loading = false;
            if (this.captchaEnabled) {
              this.getCode();
            }
          });
        }
      });
    },
    // 跳转到注册页面
    toRegister() {
      if (!this.registerEnable) {
        this.$modal.msgError('当前系统没有开放注册功能')
        return;
      }
      this.$router.replace('/register');
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  height: 100vh;
  //background-image: url("../../assets/img/bg02.jpg");
  background-image: url("../../assets/img/bg04.png");
  background-size: cover;
}

.title {
  margin: 0 auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  //background: #ffffff;
  background: rgba(255, 255, 255, 0.75);
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  //width: 37%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }

  .login-code-img {
    height: 38px;
  }
}

.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #000000;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

// 花瓣动画
.flower {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
}

.flower img {
  position: absolute;
}

/*设置花瓣飘落动画*/
@keyframes animate {
  0% {
    opacity: 0;
    top: -10px;
    transform: translateX(20px) rotate(0deg);
  }

  10% {
    opacity: 1;
  }

  20% {
    transform: translateX(-20px) rotate(45deg);
  }

  40% {
    opacity: 0.9;
    transform: translateX(-20px) rotate(90deg);
  }

  50% {
    opacity: 0.7;
  }

  60% {
    opacity: 0.7;
    transform: translateX(20px) rotate(180deg);
  }

  70% {
    opacity: 0.5;
  }

  80% {
    opacity: 0.4;
    transform: translateX(-20px) rotate(45deg);
  }

  90% {
    opacity: 0.2;
  }

  100% {
    opacity: 0.1;
    top: 110%;
    transform: translateX(20px) rotate(225deg);
  }
}

/*给8朵花瓣添加动画*/
.flower img:nth-child(1) {
  left: 5%;
  animation: animate 20s linear infinite;
}

.flower img:nth-child(2) {
  left: 10%;
  animation: animate 14s -2s linear infinite;
}

.flower img:nth-child(3) {
  left: 20%;
  animation: animate 12s -3s linear infinite;
}

.flower img:nth-child(4) {
  left: 30%;
  animation: animate 15s -2s linear infinite;
}

.flower img:nth-child(5) {
  left: 40%;
  animation: animate 18s -1s linear infinite;
}

.flower img:nth-child(6) {
  left: 45%;
  animation: animate 12s -1s linear infinite;
}

.flower img:nth-child(7) {
  left: 50%;
  animation: animate 14s -2s linear infinite;
}

.flower img:nth-child(8) {
  left: 60%;
  animation: animate 15s -1s linear infinite;
}

.flower img:nth-child(9) {
  left: 70%;
  animation: animate 12s -2s linear infinite;
}

.flower img:nth-child(10) {
  left: 80%;
  animation: animate 15s -4s linear infinite;
}

.flower img:nth-child(11) {
  left: 90%;
  animation: animate 18s -2s linear infinite;
}

.flower img:nth-child(12) {
  left: 95%;
  animation: animate 12s -1s linear infinite;
}
</style>
